module.exports = __webpack_public_path__ + "img/restaurant-5.7a8c8484.jpg";